import LanguagePack from "../../language/LanguagePack";
import EventDispatcher from "../../util/EventDispatcher";
import { isNull } from "../../util/TypeUtil";

export default class Content extends EventDispatcher {
    constructor(name, type, label, languagePack, contentID) {
        super();

        this._contentName = name;
        this._type = type;
        this._label = label;
        if (isNull(label) || label === "") {
            this._label = this.getRandomLabel();
        }
        this._languagePack = languagePack;
        this.setContentID(contentID);
    }


    getContentName() {
        return this._contentName;
    };

    getContentID() {
        return this.getLanguagePackText(Content.CONTENT_ID_LABEL);

    };

    setContentID(value) {
        if (this.getContentID() !== value) {
            this.setLanguagePackText(Content.CONTENT_ID_LABEL, value);
        }
    };

    getType() {
        return this._type;
    };

    getLabel() {
        return this._label;
    };

    setLabel(value) {
        ENGContentController.renameContent(this.getLabel(), value);
        this._label = value;
    };

    setContentValuesMetaData(value) {
        this._contentValuesMetaData = value;
    };

    getContentValuesMetaData() {
        return this._contentValuesMetaData;
    };

    setPropertiesFromObject(object) {
        if (!isNull(object["label"])) {
            this._label = object["label"];
        }

        for (var propertyName in object) {
            if (propertyName !== "label" && propertyName !== "type") {
                try {
                    var setFunction = "set" + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
                    this[setFunction](object[propertyName]);
                }
                catch (err) {
                    console.error("WARNING: Property " + propertyName + " not loaded - if it is not loaded in subclasses the data is lost.");
                }
            }
        }
    };

    convertToObject() {
        return this.getObject([]);
    };


    remove() {

    };
    getRandomLabel() {
        return this._type + Math.floor(Math.random() * Number.MAX_VALUE);
    };

    getDescriptionLabel() {
        return "content";
    };

    getLanguagePack() {
        return this._languagePack;
    };

    // --------------------- Private -------------------

    getLanguagePackLabel(id) {
        return LanguagePack.getFullLabel(id, this._label);
    };

    getLanguagePackText(id) {
        return this._languagePack.getText(id, this._label, true);
    };

    setLanguagePackText(id, value) {
        this._languagePack.setText(id, value, this._label);
    };

    removeLanguagePackText(id) {
        this._languagePack.removeText(id, this._label);
    };

    getLanguagePackContent(id, type) {
        return this._languagePack.getContent(id, type, this._label);
    };

    setLanguagePackContent(id, type, value) {
        this._languagePack.setContent(id, type, value, this._label);
    };

    removeLanguagePackContent(id, type) {
        this._languagePack.removeContent(id, type, this._label);
    };

    getObject(propertyNames) {
        var object = {};

        for (var i = 0; i < propertyNames.length; i++) {
            var propertyName = propertyNames[i];
            if (propertyName !== "label" && propertyName !== "type") {
                var getFunction = "get" + propertyName.charAt(0).toUpperCase() + propertyName.slice(1);
                object[propertyName] = this[getFunction]();
            }
        }
        object.type = this._type;
        object.label = this._label;
        return object;
    };
}

Content.CONTENT_ID_LABEL = "contentID";

